import type { RouteRecordRaw } from 'vue-router'
declare module 'vue-router' {
  interface RouteMeta {
    title: string
    public?: boolean
    showFooter?: boolean
    breadcrumb?: {
      label?: string
      path?: string
    }
  }
}
const routes: RouteRecordRaw[] = [
  {
    path: 'study',
    name: 'Study',
    meta: {
      title: '课程学习',
      breadcrumb: {
        label: '课程学习',
        path: '/study'
      }
    },
    component: () => import('@/views/study/index.vue')
    // children: [
    //   {
    //     path: 'thesis',
    //     name: 'Thesis',
    //     component: () => import('@/views/study/thesis/index.vue')
    //   }
    // ]
  },
  {
    path: 'study/myCourse',
    name: 'MyCourse',
    meta: {
      title: '我的课程',
      breadcrumb: {
        label: '我的课程',
        path: '/study/myCourse'
      }
    },
    component: () => import('@/views/study/myCourse/index.vue')
  },
  {
    path: 'study/myCourse/detail',
    name: 'MyCourseDetail',
    meta: {
      title: '课程详情',
      breadcrumb: {
        label: '课程详情',
        path: '/study/myCourse/detail',
        query: { type: 'math' }
      }
    },
    component: () => import('@/views/study/myCourse/detail/index.vue')
  },
  {
    path: '/study/myCourse/detail/answer',
    name: 'Answer',
    meta: {
      title: '作业练习',
      breadcrumb: {
        label: '作业练习',
        path: '/study',
        query: { type: 'math' }
      }
    },
    component: () =>
      import('@/views/study/myCourse/homeworkExercises/index.vue')
  },
  {
    path: '/study/myCourse/detail/process-assessment-answer',
    name: 'ProcessAssessmentAnswer',
    meta: {
      title: '综合性评价',
      // hiddenHeader: true,
      breadcrumb: {
        label: '综合性评价',
        path: '/study',
        query: { type: 'math' }
      }
    },
    component: () =>
      import('@/views/study/myCourse/processAssessmentAnswer/index.vue')
  },
  {
    path: 'study/myCourse/learn',
    name: 'MyCourseLearn',
    meta: {
      title: '课程',
      fullPage: true,
      breadcrumb: {
        label: '课程',
        path: '/study/myCourse/learn',
        query: { type: 'math' }
      }
    },
    component: () => import('@/views/study/myCourse/learn/index.vue')
  },
  {
    path: 'study/task',
    name: 'MyTask',
    meta: {
      title: '我的任务',
      breadcrumb: {
        label: '我的任务',
        path: '/study/task'
      }
    },
    component: () => import('@/views/study/task/index.vue')
  },
  {
    path: 'study/studentStatus',
    name: 'StudentStatus',
    meta: {
      title: '学籍异动'
    },
    component: () => import('@/views/study/studentStatus/index.vue')
  },
  {
    path: 'study/thesis',
    name: 'Thesis',
    component: () => import('@/views/study/thesis/index.vue')
  },
  {
    path: 'study/thesis/stage',
    name: 'ThesisStage',
    component: () => import('@/views/study/thesis/stage/index.vue')
  }
]

export default routes
